import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type DuplicatedQuoteRequestLine = ClientInferResponseBody<
  typeof contract.quoteRequestLines.duplicate,
  200
>;

export const duplicateQuoteRequestLine = async ({
  id,
  useBatch,
}: {
  id: string;
  useBatch: boolean;
}): Promise<DuplicatedQuoteRequestLine | null> => {
  const response = await api.quoteRequestLines.duplicate.mutation({
    body: {
      useBatch,
    },
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new Error("Failed to duplicate quote request line");
};
